export enum ExportType {
  EXPORT_TYPE_RETAILER = 'RETAILER',
  EXPORT_TYPE_ITEM = 'ITEM',
  EXPORT_TYPE_SALE = 'SALE',
  EXPORT_TYPE_INVENTORY = 'INVENTORY',
  EXPORT_TYPE_SHIPMENT = 'SHIPMENT',
  EXPORT_TYPE_CARD_ORDERING = 'CARD_ORDERING',
  EXPORT_TYPE_USER = 'USER',
  EXPORT_TYPE_CUSTOMER = 'CUSTOMER'
}
